const getIntersectionObserverCallback = (onViewBeacon) => {
  let intersectionTimeout;
  return ([{ isIntersecting }], intersectionObserver) => {
    if (isIntersecting) {
      // eslint-disable-next-line no-undef
      intersectionTimeout = setTimeout(() => {
        // eslint-disable-next-line no-undef
        navigator?.sendBeacon?.(onViewBeacon);
        intersectionObserver.disconnect();
      }, 1000);

      return;
    }
    // eslint-disable-next-line no-undef
    clearTimeout(intersectionTimeout);
  };
};

export const callOnViewBeacon = (targetElement, beaconUrl) => {
  if (!targetElement?.current || !beaconUrl) return;

  // eslint-disable-next-line no-undef
  const intersectionObserver = new IntersectionObserver(
    getIntersectionObserverCallback(beaconUrl),
    { threshold: 0.5 }
  );

  intersectionObserver.observe(targetElement.current);
};

export const clearCallOnViewBeacon = (targetElement) => {
  const elementFocusedOn = targetElement?.current;
  const observerAttached = elementFocusedOn?.__intersectionObserver;

  if (!elementFocusedOn || !observerAttached) return;
  observerAttached.unobserve(elementFocusedOn);
  observerAttached.disconnect();

  delete elementFocusedOn.__intersectionObserver;
};
